import { FC, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { styles } from "../stylesForgotPassword";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { schemaCreatePassword } from "../scheme";
import { useResetPasswordMutation } from "@/store/api/authApi";
import { useNavigate } from "react-router-dom";
import HeaderControl from "@/pages/SignUp/components/HeaderControl";
import CustomInput from "@/components/UI/CustomInput/CustomInput";
import TitleBlock from "@/pages/SignUp/components/TitleBlock";

interface IForgotPasswordProps {
  setForgotPasswordStep: (value: number) => void;
  otpCode: string;
}
type FormInput = {
  password: string;
  confirmPassword: string;
};
const ChangePassword: FC<IForgotPasswordProps> = ({ setForgotPasswordStep, otpCode }) => {
  const {
    control,
    handleSubmit,
    watch,
    trigger,
    setError,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schemaCreatePassword),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [resetPassword] = useResetPasswordMutation();
  const navigate = useNavigate();
  const passwordValue = watch("password");
  const confirmPasswordValue = watch("confirmPassword");

  const onSubmit = async (data: FormInput, e: any) => {
    e.preventDefault();
    try {
      await resetPassword({ otp: otpCode, password: data.password }).unwrap();
      navigate("/login");
    } catch (err: any) {
      const msg = err?.data?.message;

      if (msg === "New password must be different from current password") {
        setError("confirmPassword", {
          type: "server",
          message: msg,
        });
      }
    }
  };

  // const passwordsDoNotMatch =
  //   passwordValue && confirmPasswordValue && passwordValue !== confirmPasswordValue;

  useEffect(() => {
    if (watch("confirmPassword")) {
      trigger("confirmPassword");
    }
  }, [watch("password")]);

  return (
    <Box sx={styles.wrapper}>
      <HeaderControl onClick={() => setForgotPasswordStep(1)} logo />
      <Box sx={{ marginTop: "32px" }}>
        <TitleBlock
          title={"Change your password"}
          subtitle="Choose a new password for your account."
        />

        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{ width: "100%", marginTop: "44px" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <CustomInput
                  label="Password"
                  placeholder="Enter your password"
                  type="password"
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />

            <Controller
              name="confirmPassword"
              control={control}
              render={({ field }) => (
                <CustomInput
                  label="Confirm Password"
                  placeholder="Confirm Password"
                  type="password"
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword?.message}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Box>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={
              !passwordValue ||
              !confirmPasswordValue ||
              passwordValue !== confirmPasswordValue ||
              !!errors.password ||
              !!errors.confirmPassword
            }
            sx={[styles.continueButton, { marginTop: "2.625rem" }]}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ChangePassword;
